import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "aria-disabled"]

import LabeledSelect from '@shell/components/form/LabeledSelect';
import { useDropdownItem } from '@components/RcDropdown/useDropdownItem';
import { ref } from 'vue';

type LabeledSelectComponent = {
  focusSearch: () => void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'RcDropdownItemSelect',
  props: {
  modelValue: {
    type:    String,
    default: ''
  },
  disabled: Boolean,
  options:  {
    type: Array,
    default() {
      return [];
    }
  },
  label: {
    type:    String,
    default: ''
  }
},
  emits: ['click', 'select'],
  setup(__props, { emit: __emit }) {

/**
 * An item for a dropdown menu. Used in conjunction with RcDropdown.
 */

const emits = __emit;

const {
  handleKeydown, handleActivate, scrollIntoView, handleMouseenter
} = useDropdownItem();

const dropdownMenuItem = ref<HTMLDivElement | null>(null);
const menuItemSelect = ref<LabeledSelectComponent | null>(null);

const handleClick = () => {
  menuItemSelect?.value?.focusSearch();
};

const focusMenuItem = () => {
  dropdownMenuItem?.value?.focus();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dropdownMenuItem",
    ref: dropdownMenuItem,
    "dropdown-menu-item": "",
    tabindex: "-1",
    role: "menuitem",
    disabled: __props.disabled || null,
    "aria-disabled": __props.disabled || false,
    onClick: _withModifiers(handleClick, ["stop"]),
    onKeydown: [
      _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_unref(handleActivate) && _unref(handleActivate)(...args)), ["enter","space"])),
      _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_unref(handleKeydown) && _unref(handleKeydown)(...args)), ["prevent","stop"]), ["up","down"]))
    ],
    onFocusin: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(scrollIntoView) && _unref(scrollIntoView)(...args))),
    onMouseenter: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(handleMouseenter) && _unref(handleMouseenter)(...args)))
  }, [
    _createVNode(_unref(LabeledSelect), {
      ref_key: "menuItemSelect",
      ref: menuItemSelect,
      value: __props.modelValue,
      label: __props.label,
      options: __props.options,
      clearable: false,
      placement: "top",
      onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"])),
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (emits('select', $event))),
      onOnClose: focusMenuItem
    }, null, 8, ["value", "label", "options"])
  ], 40, _hoisted_1))
}
}

})